export namespace PBEnums {
    export enum SubscriptionType {
        ObjectStorage = "object-storage",
        Partner = "reseller-object-storage",
        Drive = "drive",
        DrivePro = "drive-pro",
        DriveSquad = "drive-squad"
    }

    export enum Roles {
        Owner = "owner",
        Admin = "admin",
        Invoice = "invoice",
        Stats = "stat",
        S3ReadOnly = "object-storage-read-only",
        None = "none"
    }

    export enum CustomerTribeType {
        Owner = "owner-tribe",
        Child = "child-tribe"
    }

    export enum ClusterTarget {
        Prod = "pro",
        Individual = "individual"
    }
}
